export class WebhookV1JobMetricsReportFailedArguments {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "cloudAccountArguments",
            "baseName": "cloudAccountArguments",
            "type": "WebhookV1CloudAccountArguments",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "error",
            "baseName": "error",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1JobMetricsReportFailedArguments.attributeTypeMap;
    }
    constructor() {
    }
}
